import { Box, Typography } from "@mui/material";
import { TopActionsProgressCardSkeleton } from "./TopActionsProgressCardSkeleton";
import { ReactNode } from "react";
import { AttachIcon } from "~/icons";

interface Props {
  loading: boolean;
}

const TopActionsProgressCardEmptyState = ({ loading }: Props) => {
  const getIcon = (): ReactNode => {
    return (
      <Box
        sx={{
          marginTop: 4.7,
          "& svg": {
            width: 36,
            height: 36,
            color: "text.secondary",
          },
        }}
      >
        <AttachIcon />
      </Box>
    );
  };

  const getNoFindingsDescription = (): ReactNode => {
    return (
      <Typography
        variant="body1"
        sx={{
          fontWeight: "medium",
          color: "text.secondary",
          textAlign: "center",
          fontSize: { xs: "14px", sm: "16px" },
          px: { xs: 1, sm: 0 },
          mb: 3,
        }}
      >
        This panel tracks progress remediating top actions.
      </Typography>
    );
  };

  if (loading) {
    return <TopActionsProgressCardSkeleton />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "calc(100% - 24px)",
        gap: { xs: 2, sm: 1 },
        p: { xs: 2, sm: 3 },
        textAlign: "center",
      }}
    >
      {getIcon()}

      <Box
        sx={{
          maxWidth: {
            xs: "100%",
            sm: 420,
          },
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "700",
            fontSize: { xs: "16px", sm: "24px" },
            mb: { xs: 1, sm: 1.5 },
          }}
        >
          No actions in progress
        </Typography>

        {getNoFindingsDescription()}
      </Box>
    </Box>
  );
};

export default TopActionsProgressCardEmptyState;
